import React from "react";

export default function ComplianceTab() {
  return (
    <div className="text-center py-8 text-white/40 text-sm">
      <p className="font-medium text-white/60 mb-1">Compliance</p>
      <p>Compliance tracking is coming soon.</p>
    </div>
  );
}
